import {
  PROJECT_INFO,
  SET_ACTIVE_PROJECT,
  SET_ACTIVE_PROJECT_STATISTICS,
  SET_PROJECT_LOCKING_STATUS,
  SET_USER_PROJECTS,
} from '@state-management/constants';
import { Action } from '../actions';
import { ProjectLockStatus, TypedCacheBucket } from '../models/state.models';

export interface ProjectStatistics {
  project_id: string;
  summary: { all: { filters: unknown; data: unknown[] }; mysales: { filters: unknown; data: unknown[] } };
  weekly: { all: { filters: unknown; data: unknown[] }; mysales: { filters: unknown; data: unknown[] } };
  monthly: { all: { filters: unknown; data: unknown[] }; mysales: { filters: unknown; data: unknown[] } };
  topselling: { all: { filters: unknown; data: unknown[] }; mysales: { filters: unknown; data: unknown[] } };
  project_info: unknown;
}

export interface ProjectReducerState {
  active_project: unknown | null;
  project_list: unknown[];
  access_control_lock: ProjectLockStatus;
  statistics: ProjectStatistics | null;
  project_info: TypedCacheBucket;
}

const initialState: ProjectReducerState = {
  active_project: null,
  project_list: [],
  access_control_lock: {
    is_locked: false,
    locked_by: '',
  },
  statistics: null,
  project_info: null,
};

export function ProjectsReducer(state = initialState, action: Action): ProjectReducerState {
  switch (action.type) {
    case SET_USER_PROJECTS: {
      const data = action.payload?.data;
      return { ...state, project_list: data ?? [] };
    }
    case SET_PROJECT_LOCKING_STATUS: {
      const data = action.payload?.data;
      return { ...state, access_control_lock: data ?? initialState.access_control_lock };
    }
    case SET_ACTIVE_PROJECT: {
      return { ...state, active_project: action.payload?.data ?? null };
    }
    case SET_ACTIVE_PROJECT_STATISTICS: {
      return { ...state, statistics: (action.payload?.data as ProjectStatistics) ?? null };
    }
    case PROJECT_INFO: {
      return { ...state, project_info: action.payload?.data ?? null };
    }
    default: {
      return state;
    }
  }
}

export const getProjectList = (state: ProjectReducerState) => state.project_list;
export const getProjectAccessControlStatus = (state: ProjectReducerState) => state.access_control_lock;
export const getActiveProject = (state: ProjectReducerState) => state.active_project;
export const getActiveProjectStatistics = (state: ProjectReducerState) => state.statistics;
export const projectInfo = (state: ProjectReducerState) => state.project_info;
